import DialogService from './main.js'

DialogService.install = (Vue, options) => {
  const { key = '$dialog', ...rest } = options
  Vue.prototype[key] = DialogService({ Vue, ...rest })
}

export default DialogService